<template>
  <div class="zmanim-list-entry__container">
    <div class="zmanim-list-entry__border" />
    <div class="zmanim-list-entry__leading-container">
      <div class="zmanim-list-entry__title">
        {{ title }}
      </div>
      <div v-if="subtitle" class="zmanim-list-entry__subtitle">
        {{ subtitle }}
      </div>
    </div>
    <div class="zmanim-list-entry__trailing-container">
      {{ time }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'ZmanimListEntry',
  props: {
    title: {
      type: String,
      default: 'Zman'
    },
    subtitle: {
      type: String,
      default: ''
    },
    time: {
      type: String,
      default: '-:-- --'
    }
  }
}
</script>

<style scoped>
.zmanim-list-entry__container {
  display: flex;
  flex-direction: row;
  flex-shrink: 0;
  flex-grow: 1;
  width: 21.31rem;
  height: 3.81rem;
  margin: 0;
  padding: 0;
  justify-content: space-between;
  align-items: center;
  background: #fff;
  /* border-bottom: 1px solid #ff8511; */
}

.zmanim-list-entry__border {
  position: absolute;
  right: 0;
  align-self: flex-end;
  width: 90%;
  height: 1px;
  background: #ff8511;
}

.zmanim-list-entry__leading-container {
  display: flex;
  flex-direction: column;
  margin-left: 1.5rem;
  flex-grow: 0;
}

.zmanim-list-entry__title {
  display: flex;
  font-family: "Avenir-Bold", sans-serif;
  font-weight: bold;
  font-size: 1rem;
  color: #000000;
  letter-spacing: -0.47px;
  text-align: left;
  margin: 0;
  flex-grow: 0;
  white-space: nowrap;
}

.zmanim-list-entry__subtitle {
  flex-grow: 0;
  font-family: "SFProText-Medium", "Avenir-Medium", sans-serif;
  font-size: 0.8125rem;
  color: #9b9b9b;
  letter-spacing: -0.38px;
  text-align: left;
  margin: 0;
  flex-grow: 1;
}

.zmanim-list-entry__trailing-container {
  display: flex;
  justify-content: flex-end;
  font-family: "Avenir-Medium";
  font-size: 0.8125rem;
  color: #747474;
  letter-spacing: -0.38px;
  text-align: right;
  padding-right: 1.19rem;
}
</style>
